import { fetchAPI } from '../utils/api';
import { asyncSleep } from '../utils/sleep';

/**
 * Get all SA users in recursive manners
 * @param user user object from redus state.user
 * @param [page=1] to sent in payload
 * @param [prevUsers=[]] compilation of users from previous result
 * @returns
 */
export const loadUsersList = async (user, page = 1, prevUsers = []) => {
  try {
    const { items, system_user_id, per_page, total } = await fetchAPI('users', {
      payload: {
        page,
        per_page: 50,
      },
    });

    const allUsers = [...prevUsers, ...items];
    if (page * per_page < total) {
      await asyncSleep(Math.random() * 500 + 100); // to reduce server load
      return loadUsersList(user, page + 1, allUsers);
    }

    return {
      list: allUsers
        .map(item => ({
          ...item,
          is_self: item.id === user?.id ? true : false,
        }))
        .sort((a, b) => {
          const aName = (a.full_name || '').toLowerCase();
          const bName = (b.full_name || '').toLowerCase();
          return aName > bName ? 1 : aName < bName ? -1 : 0;
        }),
      system_user_id,
    };
  } catch (error) {
    if (page > 1 && prevUsers.length > 0) {
      // partial data collected from previous pages — return it so UI isn't empty
      const partial = prevUsers
        .map(item => ({
          ...item,
          is_self: item.id === user?.id ? true : false,
        }))
        .sort((a, b) => {
          const nameA = a.full_name || '';
          const nameB = b.full_name || '';
          return nameA.localeCompare(nameB);
        });
      return {
        list: partial,
        system_user_id: user?.id || null,
      };
    }
    // no data at all — rethrow so react-query retries
    throw error;
  }
};

/**
 * Get all SA users in recursive manners for public
 * @param user user object from redus state.user
 * @param [page=1] to sent in payload
 * @param [prevUsers=[]] compilation of users from previous result
 * @returns
 */
export const loadUsersListPublic = async (page = 1, prevUsers = []) => {
  try {
    const resp = await fetchAPI('user/list/public', {
      method: 'POST',
      payload: {
        page,
        per_page: 40,
      },
    });

    const allUsers = [...prevUsers, ...resp.items];
    if (page * 40 < resp.total) {
      return loadUsersListPublic(page + 1, allUsers);
    }

    return allUsers;
  } catch (error) {
    return prevUsers;
  }
};
